"use client";
import React, { useState } from "react";
import MerchantFaqsAccordion from "./MerchantFaqsAccordion";
import { ArrowDown, ArrowUp } from "lucide-react";

const LIMIT = 4;

export default function ProductFaqList({ faqs }: { faqs: any[] }) {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? faqs : faqs.slice(0, LIMIT);

  return (
    <div>
      <div className="flex flex-col gap-2">
        {visible.map((faq: any, i: number) => (
          <MerchantFaqsAccordion key={i} faq={faq} index={i} />
        ))}
      </div>

      {faqs.length > LIMIT && (
        <div className="flex justify-center mt-3 pt-4">
          <button
            onClick={() => setShowAll(!showAll)}
            className="group inline-flex items-center gap-2 h-10 px-6
              border border-slate-200 hover:border-indigo-950 bg-white hover:bg-indigo-950
              text-slate-500 hover:text-white
              text-[11px] font-black uppercase tracking-[0.18em] rounded-xl
              transition-all duration-300 active:scale-95 shadow-sm"
          >
            {showAll ? (
              <> Show Less <ArrowUp size={13} strokeWidth={2.5} /> </>
            ) : (
              <> Show More <ArrowDown size={13} strokeWidth={2.5} /> </>
            )}
          </button>
        </div>
      )}
    </div>
  );
}
